import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";
import { AbsenceSalarieDto } from "../../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { EventBus } from "../../../Controls/EventBus";
import EventConstants from "../../../Controls/EventConstants";
import { EtatAbsencesEnum } from "../../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { ActionAbsencesEnum } from "../../../../dto/GenApi.iNotPaie.Dto/ActionAbsencesEnum";

@Component({
	components: {
		TableauDemande: require("./tableaux/tableauDemande/tableauDemande.vue.html"),
		TableauDemandeTerminee: require("./tableaux/tableauDemandeTerminee/tableauDemandeTerminee.vue.html"),
		TableauAnnulation: require("./tableaux/tableauAnnulation/tableauAnnulation.vue.html"),
		TableauAnnulationTerminee: require("./tableaux/tableauAnnulationTerminee/tableauAnnulationTerminee.vue.html")
	}
})
export default class EspaceSalarie extends Vue {
	public dataReady = false;
	public ongletAnnulation = 0;
	public absences: AbsenceSalarieDto[] = [];

	public absencesDemande: AbsenceSalarieDto[] = [];
	public absencesAnnulation: AbsenceSalarieDto[] = [];
	public absencesDemandeTerminee: AbsenceSalarieDto[] = [];
	public absencesAnnulationTerminee: AbsenceSalarieDto[] = [];

	public compteurAbsenceDemande = 0;
	public compteurAbsenceAnnulation = 0;
	public switchModeEnAttente = 1;

	public mounted(): void {
    	EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
    		this.fetchData();
    	});
	}

	public fetchData(): void {
    	this.dataReady = false;

    	ServicesFactoryInstance.AbsencesService.getAbsencesSalarieConnecte(data => {
    		this.absences = data;

			this.absencesDemande = this.absences.filter(x => x.Etat == EtatAbsencesEnum.EnAttenteValidationGestionnaire ||
                x.Etat == EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1 ||
                x.Etat == EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2);
			this.absencesDemandeTerminee = this.absences.filter(x => x.Etat == EtatAbsencesEnum.Valide ||
                x.Etat == EtatAbsencesEnum.Calcule ||
                x.Etat == EtatAbsencesEnum.Cloture ||
                x.Etat == EtatAbsencesEnum.Refuse);
			this.absencesAnnulation = this.absences.filter(x => x.Etat == EtatAbsencesEnum.EnAttenteAnnulationGestionnaire ||
                x.Etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1 ||
                x.Etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2);
			this.absencesAnnulationTerminee = this.absences.filter(x => x.Etat == EtatAbsencesEnum.Annule);

    		this.absencesDemande.forEach((absence) => absence.LibelleTypeAbsence = (absence.LibelleTypeAbsence != undefined) ? absence.LibelleTypeAbsence.replace("JOURS DE", "") : "");
    		this.absencesDemandeTerminee.forEach((absence) => absence.LibelleTypeAbsence = (absence.LibelleTypeAbsence != undefined) ? absence.LibelleTypeAbsence.replace("JOURS DE", "") : "");
    		this.absencesAnnulation.forEach((absence) => absence.LibelleTypeAbsence = (absence.LibelleTypeAbsence != undefined) ? absence.LibelleTypeAbsence.replace("JOURS DE", "") : "");
    		this.absencesAnnulationTerminee.forEach((absence) => absence.LibelleTypeAbsence = (absence.LibelleTypeAbsence != undefined) ? absence.LibelleTypeAbsence.replace("JOURS DE", "") : "");

    		// Compteurs
			this.compteurAbsenceDemande = this.absencesDemande.length;
			this.compteurAbsenceAnnulation = this.absencesAnnulation.length;

    		this.dataReady = true;
    	});
	}

	public switchOngletAnnulation(): void {
    	this.ongletAnnulation = (this.ongletAnnulation == 0) ? 1 : 0;
    	this.switchModeEnAttente = 1;
	}

	public demanderAnnulationAbsence(absence: AbsenceSalarieDto): void {
		this.$emit("afficherModalChangerEtatAbsence", absence, ActionAbsencesEnum.DemanderAnnulerAbsenceParSalarie);
	}

	public AnnulerAnnulationAbsence(absence: AbsenceSalarieDto): void {
		this.$emit("afficherModalChangerEtatAbsence", absence, ActionAbsencesEnum.AnnulerDemandeAnnulationAbsenceParSalarie);
	}

	public afficherModalAjouterAbsence(): void {
    	this.$emit("afficherModalAjouterAbsence");
	}

	public afficherModalDetailAbsence(data: any): void {
    	const absence = data.absence;
    	this.$emit("afficherModalDetailAbsence", { absence });
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/listeDesDemandes/espaceSalarie/espaceSalarie.ts